import { useTranslation } from 'react-i18next';

// Função para renderizar o tooltip personalizado
export const CustomTooltip = ({ active, payload, responsive=false }) => {
    const { t } = useTranslation();
    
    if (active && payload && payload.length) {
        const { name, displayName, value, percent } = payload[0].payload;
        return (
            <div style={{
                backgroundColor: '#fff',
                border: '1px solid #e8e8e8',
                borderRadius: '6px',
                padding: '12px 16px',
                boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
                fontSize: '13px',
            }}>
                <p style={{ margin: '0 0 8px 0', fontWeight: '600', color: '#262626', fontSize: '14px' }}>{displayName || name}</p>
                <p style={{ margin: '0 0 4px 0', fontWeight: '700', color: '#262626', fontSize: '24px', lineHeight: '1.2' }}>{value}</p>
                {!responsive && percent !== undefined && (
                <p style={{ margin: 0, color: '#595959' }}>{t('Dashboard.Tooltip.Percentage')}: <strong style={{ color: '#4085c6' }}>{parseFloat(percent).toFixed(2)}%</strong></p>
                )}
            </div>
        );
    }
    return null;
};